import AnalyticsFilterInputs from "../../../types/analytics/AnalyticsFilterInputs";
import UsageNudgeActionButton from "./UsageNudgeActionButton";
import UsageNudgedAgeLabel from "./UsageNudgedAgeLabel";
import { isUsageNudgeOnCooldown } from "../../../helpers/usage/usageNudgeHelpers";

interface UsageEmployeeNudgeCellProps {
  employeeId: number;
  employeeName: string;
  filters: AnalyticsFilterInputs;
  lastSentAt?: string | null;
  lastSenderName?: string | null;
  onSent: () => void;
  onSendStarted?: () => void;
  onSendFailed?: () => void;
  onCooldown?: (lastSentAt: string, senderName: string | null) => void;
}

function UsageEmployeeNudgeCell({
  employeeId,
  employeeName,
  filters,
  lastSentAt,
  lastSenderName,
  onSent,
  onSendStarted,
  onSendFailed,
  onCooldown,
}: UsageEmployeeNudgeCellProps) {
  const isOnCooldown = isUsageNudgeOnCooldown(lastSentAt) && Boolean(lastSentAt);

  return (
    <>
      {isOnCooldown && lastSentAt && (
        <UsageNudgedAgeLabel sentAt={lastSentAt} senderName={lastSenderName} />
      )}
      {/* Kept mounted while on cooldown so an optimistic send does not tear down its own modal. */}
      <UsageNudgeActionButton
        filters={filters}
        recipientEmployeeId={employeeId}
        audience="EMPLOYEE"
        recipientName={employeeName}
        lastSentAt={!isOnCooldown ? lastSentAt : undefined}
        className={isOnCooldown ? "hidden" : undefined}
        onSent={onSent}
        onSendStarted={onSendStarted}
        onSendFailed={onSendFailed}
        onCooldown={onCooldown}
      />
    </>
  );
}

export default UsageEmployeeNudgeCell;
